/* LAB PROFILE */
export const GET_LAB_SETTINGS = "GET_LAB_SETTINGS";
export const GET_LAB_SETTINGS_SUCCESS = "GET_LAB_SETTINGS_SUCCESS";
export const GET_LAB_SETTINGS_FAIL = "GET_LAB_SETTINGS_FAIL";

export const UPDATE_LAB_SETTINGS = "UPDATE_LAB_SETTINGS";
export const UPDATE_LAB_SETTINGS_SUCCESS = "UPDATE_LAB_SETTINGS_SUCCESS";
export const UPDATE_LAB_SETTINGS_FAIL = "UPDATE_LAB_SETTINGS_FAIL";
